import Routers from './router'

export default {
	install(Vue, { router, store }) {
		router.addRoute(Routers);
	}
}